export async function generatePalletLabels(
  palletLabelInfoList = [
    {
      factoryNo: 'ONT8',
      shortContainerNo: '01234',
      containerNo: 'SEKU4362742',
      palletNo: 'Pallet-20221005001'
    },
    {
      factoryNo: 'ONT8',
      shortContainerNo: '01834',
      containerNo: 'SEKU4362799',
      palletNo: 'Pallet-20221005002'
    }
  ]
) {
  let zpl
  for (const palletLabelInfo of palletLabelInfoList) {
    const { factoryNo, shortContainerNo, containerNo, palletNo } =
      palletLabelInfo
    zpl += generateZplForOneLabel(
      factoryNo,
      shortContainerNo,
      containerNo,
      palletNo
    )
  }
  const response = await fetch(
    'http://api.labelary.com/v1/printers/8dpmm/labels/4x6/',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/pdf'
      },
      body: JSON.stringify(zpl)
    }
  )
  response.blob().then(blob => showInOtherTab(blob))
}
function generateZplForOneLabel(
  factoryNo,
  shortContainerNo,
  containerNo,
  palletNo
) {
  return JSON.stringify(`^XA
  ^FX Top section with logo, name and address.
  ^CF0,60
  ^FO50,50^GFA,2888,2888,19,,:003gQFC,:01gSF8,01gSFC,07gSFE,07gTF,1gUF8,:1gUFC,7gUFE,:::::::::::::::::::::::7NFS03SFE,7MFET0SFE,7NFT01RFE,7NF8T0BQFE,7NFET01QFE,7NFEU0QFE,7OF8T03PFE,7OF8U0PFE,7OFCU0PFE,7OFEU03OFE,7PFU03OFE,7PF8T01OFE,7PFCU0OFE,7PFEU07NFE,7QFU07NFE,7QF8T01NFE,7QFCT01NFE,7QFET01NFE,7RF8T0NFE,:7gGFL0NFE,7gGFL07MFE,7gGFCK07MFE,7gGFEK03MFE,7gHFK03MFE,7gHF8J03MFE,::7gHFCJ03MFE,7gHFEJ03MFE,:7gHFCJ03MFE,7gHF8J03MFE,::7gHF8J07MFE,:7gGFCK07MFE,:7gFEL07MFE,7NFL03IFO0NFE,7MFEL01FFEN01NFE,7NFM07FFN01NFE,7NF8L07FF8M01NFE,7NFCL01FFCM03NFE,7NFEL01FFEM07NFE,7OFM07FFM07NFE,7OF8L07FF8L07NFE,7OFCL01FFCK01OFE,7OFEL01FFEK01OFE,7PFM0IFK03OFE,7PF8L03FFCJ07OFE,7PFCL03FFCJ0PFE,7PFEM0FFEI01PFE,7QFM0IFI03PFE,7QF8L07FF800QFE,7QFCL01FFC03QFE,7QFEL01FFE07QFE,7RF8L07FF7RFE,7RF8L07UFE,7RFEL01UFE,:7SFM0UFE,7SF8L03TFE,7SFCL03TFE,7SFEM0TFE,7TFM0TFE,7TF8L03SFE,7TFCL03SFE,7TFEL01SFE,7UFM07RFE,7UF8L07RFE,7UFCL01RFE,7UFEL01RFE,7VFM0RFE,7VF8L03QFE,7VFCL03QFE,7VFEM0QFE,7WFM0QFE,7WFCL03PFE,7WFCL07PFE,7gUFE,:::::::::::::::::::::::1gUFC,1gUF8,:07gTF,:03gSFC,01gSFC,003gQFC,I0gQF,,::^FS
  ^FO220,50^FDRII Express^FS
  ^CF0,30
  ^FO220,115^FD14950 Valley View Ave^FS
  ^FO220,155^FDLa Mirada, CA 90638^FS
  ^FO220,195^FDUnited States (USA)^FS
  ^FO50,250^GB700,3,3^FS
  
  ^FX Second section with recipient address and permit information.
  ^CF0,190
  ^FO180,300^FD${factoryNo}^FS
  ^FO50,490^GB700,3,3^FS
  
  ^CF0,190
  ^FO165,540^FD${shortContainerNo}^FS
  ^CF0,30
  ^FO325,700^FD${containerNo}^FS
  ^FO50,770^GB700,3,3^FS
  
  ^FX Third section with bar code.
  ^BY3,2,270
  ^FO175,820^BC^FD${palletNo}^FS
  
  
  ^XZ`)
}

function showInOtherTab(blob) {
  const url = window.URL.createObjectURL(blob)
  window.open(url)
}
